import http from "./httpService";

const endPoint = "/api/v1/LogisticMovement";

export function getAllMovements(request) {
    return http.post(`${endPoint}/GetAll`, request);
}

export function getMovement(id) {
    return http.get(`${endPoint}/${id}`);
}

export function cancelMovement(id) {
    return http.post(`${endPoint}/${id}/Cancel`);
}

export function createMovement(movement) {
    return http.post(`${endPoint}`, movement);
}

const obj = {
    getMovement,
    cancelMovement,
    createMovement,
    getAllMovements
};

export default obj;


// WEBPACK FOOTER //
// ./src/services/logisticMovementService.js